function wsProtocol(){
  const protocol = window.location.protocol;
  if(protocol === "https:") {
    return 'wss:';
  } else {
    return 'ws:';
  }
}

function handleHttps(url){
  if(url && url.startsWith("http:")){
    url = window.location.protocol + url.substring(5);
  }
  return url;
}

function changeTime(utcTime){
  let z = utcTime.indexOf('+');
  utcTime=utcTime.replace('T',' ').slice(0,z)
 return utcTime
}
function deepClone(obj) {
  if (typeof obj !== 'object') {
    return obj;
  }
  if (obj == null) {
    return null;
  }
  if (obj instanceof RegExp) {
    return new RegExp(obj);
  }
  if (obj instanceof Date) {
    return new Date(obj);
  }
  let instance = new obj.constructor();
  Object.keys(obj).forEach(function(key){
    instance[key] = typeof obj[key] === 'object' ? deepClone(obj[key]) : obj[key]
  });
  return instance;
}

export default {
  wsProtocol,
  handleHttps,
  changeTime,
  deepClone
}



// WEBPACK FOOTER //
// ./src/lib/utils.js